<script setup>
const props = defineProps({
  modelValue: {
    type: [Boolean, null],
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  preventCenter: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const toggle = () => {
  emit('update:modelValue', !props.modelValue);
  emit('change', !props.modelValue);
};

const handleChange = (event) => {
  emit('update:modelValue', event.target.checked);
  emit('change', event.target.checked);
};
</script>

<template>
  <div
    :class="['base-toggle', { 'center-toggle': !label && !preventCenter }]"
    @click.stop.prevent="toggle"
  >
    <label
      v-if="label"
      class="toggle-label"
      @click.stop.prevent
    >{{ label }}</label>
    <div class="toggle-wrapper">
      <label class="switch">
        <input
          type="checkbox"
          :checked="modelValue"
          @change.stop.prevent="handleChange"
        >
        <span class="slider" />
      </label>
    </div>
  </div>
</template>

<style scoped>
.base-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}

.center-toggle {
  justify-content: center;
}

.toggle-label {
  cursor: pointer;
  flex: 1;
}

.toggle-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
